<template>
  <v-container fluid>
    <v-row justify="center">
      <h2>{{ $t('title_HallOfFameFutures') }}</h2>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HallOfFameFutures"
}
</script>

<style scoped>

</style>


